import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';

import { LoadingSpinner } from '../../../shared/ui';
import { appendYowanPreviewQueryIfNeeded } from '../../../app/host/yowanPreviewRouting';
import {
  cancelYowanAdminSeminarApplication,
  fetchYowanAdminSeminarApplicationList,
  fetchYowanAdminSeminarDetail,
} from '../app/yowanContentClient';
import {
  AdminBlogShell,
  AdminListPagination,
  AdminListToolbar,
  AdminPageHeader,
  usePreservedDomainSearch,
} from './AdminBlogListPage';
const { yowanPageContent } = require('./pageContent');

const APPLICATIONS_PAGE_SIZE = 30;
const applicationSortOptions = [
  { value: 'created-desc', label: '申込日が新しい順' },
  { value: 'email-asc', label: 'email 昇順' },
  { value: 'email-desc', label: 'email 降順' },
  { value: 'classification-asc', label: '区分昇順' },
  { value: 'classification-desc', label: '区分降順' },
  { value: 'fee-asc', label: '参加費昇順' },
  { value: 'fee-desc', label: '参加費降順' },
  { value: 'name-asc', label: '氏名昇順' },
  { value: 'name-desc', label: '氏名降順' },
];

const actionColumnStyle = {
  width: '20rem',
  minWidth: '20rem',
};

const classificationColumnStyle = {
  width: '7.5rem',
  minWidth: '7.5rem',
};

const feeColumnStyle = {
  width: '7.5rem',
  minWidth: '7.5rem',
};

const participationColumnStyle = {
  width: '14rem',
  minWidth: '14rem',
};

const appliedAtColumnStyle = {
  width: '10rem',
  minWidth: '10rem',
};

const operationButtonStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '1.85rem',
  padding: '0.26rem 0.72rem',
  border: 'none',
  borderRadius: '999px',
  background: 'rgba(116, 126, 115, 0.16)',
  color: '#2f363d',
  fontSize: '0.82rem',
  fontWeight: 600,
  lineHeight: 1.2,
  textDecoration: 'none',
};

const cancelButtonStyle = {
  ...operationButtonStyle,
  background: 'rgba(124, 42, 46, 0.12)',
  color: '#7c2a2e',
  cursor: 'pointer',
};

const relatedSectionStyle = {
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  columnGap: '0.65rem',
  rowGap: '0.5rem',
  marginBlock: '0.75rem 1.25rem',
};

const relatedLabelStyle = {
  margin: 0,
  color: 'rgba(47, 54, 61, 0.72)',
  fontSize: '0.95rem',
  lineHeight: 1.5,
};

const relatedListStyle = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: '0.5rem',
};

const relatedLinkStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '2rem',
  padding: '0.3rem 0.9rem',
  border: 'none',
  borderRadius: '999px',
  background: 'rgba(116, 126, 115, 0.16)',
  color: '#2f363d',
  fontSize: '0.9rem',
  fontWeight: 500,
  lineHeight: 1.2,
  textDecoration: 'none',
  boxShadow: 'none',
};

const mailLinkStyle = {
  ...relatedLinkStyle,
  background: 'rgba(124, 42, 46, 0.14)',
  color: '#7c2a2e',
  fontWeight: 700,
};

const slotSummarySectionStyle = {
  display: 'grid',
  gap: '0.75rem',
  marginBlock: '0 1rem',
  padding: '0.9rem',
};

const slotSummaryHeaderStyle = {
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '0.75rem',
};

const slotSummaryTitleStyle = {
  margin: 0,
  color: '#2f363d',
  fontSize: '0.95rem',
  fontWeight: 700,
  lineHeight: 1.4,
};

const slotFilterStyle = {
  minHeight: '2rem',
  maxWidth: '18rem',
  padding: '0.28rem 0.7rem',
  border: '1px solid rgba(47, 54, 61, 0.22)',
  borderRadius: '0.45rem',
  background: '#fff',
  color: '#2f363d',
  fontSize: '0.9rem',
};

const slotSummaryGridStyle = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(13rem, 1fr))',
  gap: '0.6rem',
};

const slotSummaryItemStyle = {
  display: 'grid',
  gap: '0.42rem',
  padding: '0.72rem',
  border: '1px solid rgba(47, 54, 61, 0.14)',
  borderRadius: '0.5rem',
  background: 'rgba(116, 126, 115, 0.08)',
};

const slotSummaryItemTitleStyle = {
  margin: 0,
  color: '#2f363d',
  fontSize: '0.88rem',
  fontWeight: 700,
  lineHeight: 1.4,
};

const slotSummaryMetaStyle = {
  margin: 0,
  color: 'rgba(47, 54, 61, 0.72)',
  fontSize: '0.78rem',
  lineHeight: 1.45,
};

const slotSummaryCountStyle = {
  margin: 0,
  color: '#7c2a2e',
  fontSize: '1rem',
  fontWeight: 700,
  lineHeight: 1.2,
};

const slotChipListStyle = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: '0.35rem',
  margin: 0,
  padding: 0,
  listStyle: 'none',
};

const slotChipStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  minHeight: '1.55rem',
  padding: '0.18rem 0.54rem',
  borderRadius: '999px',
  background: 'rgba(89, 102, 116, 0.12)',
  color: '#2f363d',
  fontSize: '0.76rem',
  fontWeight: 600,
  lineHeight: 1.2,
};

const rowScopeStyle = {
  margin: '0 0 0.38rem',
  color: 'rgba(47, 54, 61, 0.7)',
  fontSize: '0.76rem',
  fontWeight: 700,
  lineHeight: 1.3,
};

const getSlotDisplayLabel = (slot = {}) => (
  [slot.title, slot.datetimeLabel].filter(Boolean).join(' / ') ||
  slot.label ||
  slot.datetimeLabel ||
  slot.startLabel ||
  slot.id ||
  '-'
);

const getSlotColumnLabel = (slot = {}) => (
  slot.title ||
  slot.slotTitle ||
  slot.label ||
  slot.datetimeLabel ||
  slot.startLabel ||
  slot.id ||
  '-'
);

const getSlotOnlyFallbackLabels = (labels = []) => labels.flatMap((label) => {
  const withoutSeminarTitle = String(label || '').replace(/^.*?:\s*/, '').trim();
  const parenthesized = withoutSeminarTitle.match(/\(([^)]+)\)\s*$/);
  const slotText = parenthesized?.[1] || withoutSeminarTitle;

  return slotText
    .split(/[、,]/)
    .map((value) => value.trim())
    .filter(Boolean);
});

const getSlotLocationLabel = (slot = {}) => (
  slot.locationLabel ||
  slot.publicLocationLabel ||
  slot.roomName ||
  slot.address ||
  ''
);

const isFullParticipationScope = (scope = '') => ['series', 'event', 'seminar', 'full'].includes(scope);

const getApplicationCoveredSlots = (row = {}, eventSlots = []) => {
  if (!eventSlots.length) {
    return Array.isArray(row.coveredSlots) ? row.coveredSlots : [];
  }

  if (isFullParticipationScope(row.participationScope)) {
    return eventSlots;
  }

  const coveredSlots = Array.isArray(row.coveredSlots) ? row.coveredSlots : [];
  const coveredSlotIds = new Set([
    row.slotId,
    ...coveredSlots.map((slot) => slot.id),
  ].filter(Boolean).map(String));
  const coveredSlotLabels = new Set(coveredSlots.map(getSlotDisplayLabel).filter(Boolean));

  return eventSlots.filter((slot) => {
    if (coveredSlotIds.has(String(slot.id))) {
      return true;
    }

    return coveredSlotLabels.has(getSlotDisplayLabel(slot));
  });
};

const getFeeValue = (feeLabel) => {
  const normalizedFee = String(feeLabel || '').replace(/[^\d]/g, '');
  const parsedFee = Number.parseInt(normalizedFee, 10);

  return Number.isNaN(parsedFee) ? 0 : parsedFee;
};

const sortApplicationRows = (rows, sortKey) => {
  const nextRows = [...rows];

  nextRows.sort((left, right) => {
    if (sortKey === 'email-asc') {
      return left.applicantEmail.localeCompare(right.applicantEmail, 'ja');
    }

    if (sortKey === 'email-desc') {
      return right.applicantEmail.localeCompare(left.applicantEmail, 'ja');
    }

    if (sortKey === 'classification-asc') {
      if (left.classificationLabel === right.classificationLabel) {
        return left.applicantName.localeCompare(right.applicantName, 'ja');
      }
      return left.classificationLabel.localeCompare(right.classificationLabel, 'ja');
    }

    if (sortKey === 'classification-desc') {
      if (left.classificationLabel === right.classificationLabel) {
        return left.applicantName.localeCompare(right.applicantName, 'ja');
      }
      return right.classificationLabel.localeCompare(left.classificationLabel, 'ja');
    }

    if (sortKey === 'fee-asc') {
      if (getFeeValue(left.slotFeeLabel) === getFeeValue(right.slotFeeLabel)) {
        return left.applicantName.localeCompare(right.applicantName, 'ja');
      }
      return getFeeValue(left.slotFeeLabel) - getFeeValue(right.slotFeeLabel);
    }

    if (sortKey === 'fee-desc') {
      if (getFeeValue(left.slotFeeLabel) === getFeeValue(right.slotFeeLabel)) {
        return left.applicantName.localeCompare(right.applicantName, 'ja');
      }
      return getFeeValue(right.slotFeeLabel) - getFeeValue(left.slotFeeLabel);
    }

    if (sortKey === 'name-asc') {
      return left.applicantName.localeCompare(right.applicantName, 'ja');
    }

    if (sortKey === 'name-desc') {
      return right.applicantName.localeCompare(left.applicantName, 'ja');
    }

    const leftDate = Date.parse(left.createdAt.replace(' ', 'T'));
    const rightDate = Date.parse(right.createdAt.replace(' ', 'T'));
    const safeLeft = Number.isNaN(leftDate) ? 0 : leftDate;
    const safeRight = Number.isNaN(rightDate) ? 0 : rightDate;
    return safeRight - safeLeft;
  });

  return nextRows;
};

const AdminEventApplicationsListPage = () => {
  const content = yowanPageContent['/admin/events/:eventId/applications'];
  const preservedDomainSearch = usePreservedDomainSearch();
  const { eventId } = useParams();
  const [searchQuery, setSearchQuery] = useState('');
  const [sortKey, setSortKey] = useState('created-desc');
  const [slotFilterId, setSlotFilterId] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [eventRecord, setEventRecord] = useState(null);
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [loadError, setLoadError] = useState('');
  const [operationMessage, setOperationMessage] = useState('');

  useEffect(() => {
    let isMounted = true;

    setIsLoading(true);
    setLoadError('');
    setSlotFilterId('');

    Promise.all([
      fetchYowanAdminSeminarApplicationList({ seminarId: eventId, status: 'applied' }),
      fetchYowanAdminSeminarDetail(eventId).catch(() => null),
    ])
      .then(([payload, seminarDetail]) => {
        if (!isMounted) {
          return;
        }

        setRows(payload.results);
        setEventRecord(seminarDetail);
      })
      .catch(() => {
        if (!isMounted) {
          return;
        }

        setRows([]);
        setEventRecord(null);
        setLoadError('セミナー参加者一覧を読み込めませんでした。');
      })
      .finally(() => {
        if (isMounted) {
          setIsLoading(false);
        }
      });

    return () => {
      isMounted = false;
    };
  }, [eventId]);

  if (!content) {
    return null;
  }

  const headerTitle = eventRecord ? `${eventRecord.title} 参加者一覧` : content.header.title;
  const eventSlots = Array.isArray(eventRecord?.slots) ? eventRecord.slots : [];
  const slotSummaryRows = eventSlots.map((slot) => {
    const fallbackParticipantCount = rows.filter((row) =>
      getApplicationCoveredSlots(row, eventSlots).some((coveredSlot) => String(coveredSlot.id) === String(slot.id)),
    ).length;
    const hasApiParticipantCount = slot.hasApplicationsCount === true;
    const participantCount = hasApiParticipantCount ? slot.applicationsCount : fallbackParticipantCount;

    return {
      ...slot,
      displayLabel: getSlotDisplayLabel(slot),
      locationLabel: getSlotLocationLabel(slot),
      participantCount,
      hasApiParticipantCount,
    };
  });
  const selectedSlot = slotFilterId
    ? eventSlots.find((slot) => String(slot.id) === String(slotFilterId)) || null
    : null;
  const normalizedQuery = searchQuery.trim().toLowerCase();
  const slotFilteredRows = selectedSlot
    ? rows.filter((row) =>
        getApplicationCoveredSlots(row, eventSlots).some((slot) => String(slot.id) === String(selectedSlot.id)),
      )
    : rows;
  const filteredRows = normalizedQuery
    ? slotFilteredRows.filter((row) =>
        [
          row.applicantName,
          row.applicantEmail,
          row.classificationLabel,
          row.slotParticipationLabel,
          row.participationScopeLabel,
          row.slotFeeLabel,
          ...getApplicationCoveredSlots(row, eventSlots).map(getSlotDisplayLabel),
        ]
          .filter(Boolean)
          .some((value) => String(value).toLowerCase().includes(normalizedQuery)),
      )
    : slotFilteredRows;
  const sortedRows = sortApplicationRows(filteredRows, sortKey);
  const totalPages = Math.max(1, Math.ceil(sortedRows.length / APPLICATIONS_PAGE_SIZE));
  const safeCurrentPage = Math.min(currentPage, totalPages);
  const startIndex = (safeCurrentPage - 1) * APPLICATIONS_PAGE_SIZE;
  const visibleRows = sortedRows.slice(startIndex, startIndex + APPLICATIONS_PAGE_SIZE);
  const relatedLinks = [
    ...(content.relatedLinks || []),
    eventRecord ? { label: 'セミナー編集', href: `/admin/events/${eventId}/edit?kind=seminar` } : null,
    eventRecord ? { label: '申込メッセージ一覧', href: `/admin/events/${eventId}/application-messages` } : null,
  ].filter(Boolean);
  const buildMailHref = (params = {}) => {
    const searchParams = new URLSearchParams();
    const domain = new URLSearchParams(preservedDomainSearch).get('domain');

    if (domain) {
      searchParams.set('domain', domain);
    }

    Object.entries(params).forEach(([key, value]) => {
      if (value) {
        searchParams.set(key, value);
      }
    });

    const queryString = searchParams.toString();
    return `/admin/events/${eventId}/applications/mail${queryString ? `?${queryString}` : ''}`;
  };
  const buildApplicationDetailHref = (applicationId) =>
    appendYowanPreviewQueryIfNeeded(`/admin/events/seminars/applications/${applicationId}`, preservedDomainSearch);
  const handleForceCancel = (row) => {
    const confirmed = window.confirm('強制キャンセルを実行します。この処理は取り消せません');

    if (confirmed) {
      setOperationMessage('キャンセル処理中です。');
      cancelYowanAdminSeminarApplication(row.id)
        .then(async () => {
          setRows((currentRows) => currentRows.filter((currentRow) => currentRow.id !== row.id));
          const [applicationsResult, seminarDetailResult] = await Promise.allSettled([
            fetchYowanAdminSeminarApplicationList({ seminarId: eventId, status: 'applied' }),
            fetchYowanAdminSeminarDetail(eventId),
          ]);

          if (applicationsResult.status === 'fulfilled') {
            setRows(applicationsResult.value.results);
          }

          if (seminarDetailResult.status === 'fulfilled') {
            setEventRecord(seminarDetailResult.value);
          }

          setOperationMessage(`${row.applicantName} の強制キャンセルを受け付けました。`);
        })
        .catch(() => {
          setOperationMessage('強制キャンセルを実行できませんでした。状態を確認してください。');
        });
    }
  };

  return (
    <AdminBlogShell activeNavHref={content.activeNavHref} routeKey={content.routeKey}>
      <AdminPageHeader
        title={headerTitle}
        paragraphs={[]}
        actions={[]}
      />

      <AdminListToolbar
        searchValue={searchQuery}
        onSearchChange={(event) => {
          setSearchQuery(event.target.value);
          setCurrentPage(1);
        }}
        sortValue={sortKey}
        onSortChange={(event) => {
          setSortKey(event.target.value);
          setCurrentPage(1);
        }}
        metaText={`${sortedRows.length}件中 ${visibleRows.length}件を表示${
          totalPages > 1 ? ` / ${safeCurrentPage} / ${totalPages}ページ` : ''
        }`}
        searchPlaceholder="氏名 / メールアドレス / 区分 / 参加費 / コマ"
        sortOptions={applicationSortOptions}
      />

      <div style={relatedSectionStyle}>
        <p className="yowan-admin-page-header__lead" style={relatedLabelStyle}>
          関連するリンク
        </p>
        <div style={relatedListStyle}>
          {relatedLinks.map((item) => (
            <Link key={item.href} style={relatedLinkStyle} to={appendYowanPreviewQueryIfNeeded(item.href, preservedDomainSearch)}>
              {item.label}
            </Link>
          ))}
          {eventRecord ? (
            <Link style={mailLinkStyle} to={buildMailHref({ mode: 'all' })}>
              参加者・関係者へメール送信
            </Link>
          ) : null}
        </div>
      </div>

      {!isLoading && !loadError && slotSummaryRows.length ? (
        <section className="c-surface-content" style={slotSummarySectionStyle} aria-label="コマ別参加状況">
          <div style={slotSummaryHeaderStyle}>
            <h2 style={slotSummaryTitleStyle}>コマ別参加状況</h2>
            <select
              aria-label="表示するコマ"
              style={slotFilterStyle}
              value={slotFilterId}
              onChange={(event) => {
                setSlotFilterId(event.target.value);
                setCurrentPage(1);
              }}
            >
              <option value="">すべての参加者</option>
              {slotSummaryRows.map((slot) => (
                <option key={slot.id || slot.displayLabel} value={slot.id}>
                  {slot.displayLabel}
                </option>
              ))}
            </select>
          </div>
          <div style={slotSummaryGridStyle}>
            {slotSummaryRows.map((slot) => (
              <div key={slot.id || slot.displayLabel} style={slotSummaryItemStyle}>
                <p style={slotSummaryItemTitleStyle}>{slot.displayLabel}</p>
                {slot.locationLabel ? <p style={slotSummaryMetaStyle}>{slot.locationLabel}</p> : null}
                <p style={slotSummaryCountStyle}>
                  {slot.participantCount}名{slot.capacity ? ` / 定員 ${slot.capacity}名` : ''}
                </p>
                <Link style={operationButtonStyle} to={buildMailHref({ mode: 'slot', slotId: slot.id })}>
                  このコマへ連絡
                </Link>
              </div>
            ))}
          </div>
        </section>
      ) : null}

      {isLoading ? (
        <div className="yowan-admin-form c-surface-content">
          <LoadingSpinner label="セミナー参加者一覧を読み込み中" showLabel />
        </div>
      ) : null}
      {!isLoading && loadError ? (
        <p className="yowan-admin-form__message">{loadError}</p>
      ) : null}
      {operationMessage ? (
        <p className="yowan-admin-form__message">{operationMessage}</p>
      ) : null}

      {!isLoading && !loadError ? (
      <div className="yowan-admin-resource-table-wrap c-surface-content">
        <table className="yowan-admin-resource-table">
          <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">参加者</th>
              <th scope="col" style={classificationColumnStyle}>区分</th>
              <th scope="col" style={feeColumnStyle}>参加費</th>
              <th scope="col" style={participationColumnStyle}>参加するコマ</th>
              <th scope="col" style={appliedAtColumnStyle}>申込日</th>
              <th scope="col" style={actionColumnStyle}>運用</th>
            </tr>
          </thead>
          <tbody>
            {visibleRows.map((row, index) => {
              const coveredSlots = getApplicationCoveredSlots(row, eventSlots);
              const coveredSlotLabels = coveredSlots.map(getSlotColumnLabel).filter(Boolean);
              const fallbackSourceLabels = row.slotParticipationLabels?.length ? row.slotParticipationLabels : [row.slotParticipationLabel].filter(Boolean);
              const fallbackLabels = getSlotOnlyFallbackLabels(fallbackSourceLabels);
              const displayLabels = coveredSlotLabels.length ? coveredSlotLabels : fallbackLabels;

              return (
                <tr key={row.id}>
                  <td>{startIndex + index + 1}</td>
                  <td>
                    <p className="yowan-admin-resource-table__title">{row.applicantName}</p>
                    <p className="yowan-admin-resource-table__subline">{row.applicantEmail}</p>
                    {row.hasIdentityObservations ? (
                      <p className="yowan-admin-resource-table__subline">同一メールアドレスの観測履歴あり</p>
                    ) : null}
                  </td>
                  <td style={classificationColumnStyle}>{row.classificationLabel}</td>
                  <td style={feeColumnStyle}>{row.slotFeeLabel || '-'}</td>
                  <td style={participationColumnStyle}>
                    <p style={rowScopeStyle}>{row.participationScopeLabel || '-'}</p>
                    {displayLabels.length ? (
                      <ul style={slotChipListStyle}>
                        {displayLabels.map((label) => (
                          <li key={label} style={slotChipStyle}>{label}</li>
                        ))}
                      </ul>
                    ) : (
                      row.slotParticipationLabel || '-'
                    )}
                  </td>
                  <td style={appliedAtColumnStyle}>{row.createdAt}</td>
                  <td style={actionColumnStyle}>
                    <div className="yowan-admin-resource-table__actions">
                      <Link style={operationButtonStyle} to={buildApplicationDetailHref(row.id)}>
                        詳細
                      </Link>
                      <Link style={operationButtonStyle} to={buildMailHref({ mode: 'single', applicationId: row.id })}>
                        連絡
                      </Link>
                      <button type="button" style={cancelButtonStyle} onClick={() => handleForceCancel(row)}>
                        強制キャンセル
                      </button>
                    </div>
                  </td>
                </tr>
              );
            })}
            {!visibleRows.length ? (
              <tr>
                <td colSpan="7">参加者はまだありません。</td>
              </tr>
            ) : null}
          </tbody>
        </table>
      </div>
      ) : null}

      <AdminListPagination
        currentPage={safeCurrentPage}
        totalPages={totalPages}
        onPageChange={setCurrentPage}
      />
    </AdminBlogShell>
  );
};

export default AdminEventApplicationsListPage;
